import { render } from "./BeneficiarioSolicitudComponent.vue?vue&type=template&id=08a9e7d2&scoped=true"
import script from "./BeneficiarioSolicitudComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiarioSolicitudComponent.vue?vue&type=script&lang=js"

import "./BeneficiarioSolicitudComponent.vue?vue&type=style&index=0&id=08a9e7d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9e7d2"]])

export default __exports__